// organizationSlice.js
import { createSlice } from "@reduxjs/toolkit";

const organizationSlice = createSlice({
    name: "organizations",
    initialState: {},
    reducers: {
        registerOrganization: (state, action) => {
            const organization = action.payload;
            if (!organization?.id) return;

            if (!state[organization.id]) {
                state[organization.id] = organization;
            } else {
                console.warn(
                    `⚠️ Organization ${organization.id} already exists — skipping overwrite.`
                );
            }
        },

        bulkRegisterOrganizations: (state, action) => {
            action.payload.forEach((organization) => {
                if (!organization?.id) return;

                if (!state[organization.id]) {
                    state[organization.id] = organization;
                } else {
                    console.warn(
                        `⚠️ Organization ${organization.id} already exists — skipping overwrite.`
                    );
                }
            });
        }
    }
});

export const { registerOrganization, bulkRegisterOrganizations } = organizationSlice.actions;
export default organizationSlice.reducer;
